import type { AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

const APS_UNSUPPORTED_PLACEMENTS = new Set<AdType>(['rewarded', 'video_banner'])

export const APS: HbBidderConfig = {
    bidder: 'aps',
    params: ({ adSource, placement }) => {
        if (adSource !== 'portal' || APS_UNSUPPORTED_PLACEMENTS.has(placement)) {
            return undefined
        }

        return {}
    },
}
